export default function TopGradient({ children }) {
  return (
    <div className='mb-16 bg-gradient-to-b from-purple-900 to-black'>
      {children}
    </div>
  )
}
